import { Routes } from "@angular/router";
import { AuthGuard } from "src/app/core/guards/auth.guard";

export const RewardCapsRoutes: Routes = [
  {
    path: "reward-caps",
    loadComponent: () =>
      import("./reward-caps/reward-caps.component").then(
        (m) => m.RewardCapsComponent,
      ),
    canActivate: [AuthGuard],
    children: [
      {
        path: "",
        loadComponent: () =>
          import("./reward-caps-list/reward-caps-list.component").then(
            (m) => m.RewardCapsListComponent,
          ),
      },
      {
        path: "add",
        loadComponent: () =>
          import("./reward-caps-form/reward-caps-form.component").then(
            (m) => m.RewardCapsFormComponent,
          ),
      },
      {
        path: "view/:id",
        loadComponent: () =>
          import("./reward-caps-form/reward-caps-form.component").then(
            (m) => m.RewardCapsFormComponent,
          ),
      },
    ],
  },
];
